import { inject, TYPES, injectable } from "@/arch/@core/main";
import { HttpClient } from "@/arch/@core/gateway/HttpClient";
import { ModalityDataGateway } from "@/arch/@core/application/protocols/ModalityDataGateway";
import { GatewayResponse } from "@/arch/@core/adapter/gateways/protocols/GatewayInterface";

@injectable()
export class ModalityGateway implements ModalityDataGateway {
  constructor(@inject(TYPES.HttpClient) private httpClient: HttpClient) {}
  getModalities(): Promise<GatewayResponse<any>> {
    return this.httpClient.get({
      url: "/public/modalities",
    });
  }

  getModalitiesByCovenant(covenantId: string | number): Promise<GatewayResponse<any>> {
    return this.httpClient.get({
      url: `/covenants/${covenantId}/modalities`,
    });
  }

  getModalitiesWithoutFilter(): Promise<GatewayResponse<any>> {
    return this.httpClient.get({
      url: "/public/modalities",
    });
  }
}
